import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Admin } from '../../../admin/models/Admin';
import { AdminService } from '../../../admin/services/AdminService';
import { SessionService  } from '../../../admin/services/SessionService';
import { LocalStorageService  } from '../../../core/services/LocalStorageService';
import { Subscription }   from 'rxjs/Subscription';
import  {devEnv,localEnv,testEnv,stagingEnv,procEnv, demoEnv, bisHanoiEnv, bisHanoiDevEnv} from '../../../../config/config'

@Component({
    selector: 'admin-header-auth',
    template: require('./AdminHeaderAuthComponent.html'),
    styles: [require('./AdminHeaderAuthComponent.sass')]
})

export class AdminHeaderAuthComponent implements OnInit{
    @Input() module: string;
    private headerName: string;
    private subscription: Subscription;
    private adminData: Admin;
    private sidebarStatus: boolean;
	private hostName: string;
    private errorMessage: string;
    // For logout navigate
  
    constructor(
        private adminService: AdminService,
        private sessionService: SessionService,
        private router: Router,
    ) { }

    ngOnInit() {
        this.getSession();
        this.hostName = window.location.hostname;
        this.headerName = this.getHeaderName(this.module);

        this.subscription = this.adminService.adminDataChanged$.subscribe(
            admin => {
                this.onSessionChanged(admin);
            }
        );
        // Get Admin session
        this.adminData = this.adminService.getAdminSessionData();
    }

    ngOnDestroy() {
        // Destroy the subscription for session changes
        this.subscription.unsubscribe();
    } 

    private onSessionChanged(admin: Admin) {
        //TO DO: update menu content when session changed
        this.adminData = admin;
        this.sidebarStatus = this.getSidebarStatus();
    }

    private getSession() : void{
        this.sessionService.getSession()
            .subscribe(
                admin => {
                    this.adminData = admin
                    this.sidebarStatus = this.getSidebarStatus();
                },
                error => {
                }
            );
    }
    
    toHomePage() {
        // Redirect to desired URL                    
        if(Object.values(devEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${devEnv.services}`;
		}
		else if(Object.values(testEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${testEnv.services}`;
        }
        else if(Object.values(bisHanoiEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${bisHanoiEnv.services}`;
        }
        else if(Object.values(bisHanoiDevEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${bisHanoiDevEnv.services}`;
		}
		else if(Object.values(stagingEnv).indexOf(this.hostName) !== -1){
			return window.location.href =  `https://${stagingEnv.services}`;
		}
		else if(Object.values(procEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `https://${procEnv.services}`;
		}
        else if(Object.values(demoEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${demoEnv.services}`;
		}
		else{
			return window.location.href = `http://${localEnv.services}`;
		}
    }

    // Detect sidebar vibibility
    private getSidebarStatus() {
        return !this.adminData ? false : true;
    }
    
    private getHeaderName(moduleName: string): string {
        let headerName = "";

        switch(this.module) {
            case "camp":
                headerName = "Camp Programmes Management";
                break;
            case "asa":
                headerName = "After School Activities Management";
                break;
            case "bus":
                headerName = "Bus Management";
                break;
            case "reen":
                headerName = "Re-enrolment";
                break;
            case "conference":
                headerName = "Conference Booking System";
                break;
            default:
                break;
        }
        
        return headerName;
    }

    // Log our function
    private deleteSession() {
        // In case system login and booking for parent. Then, logout and login again with role parent to booking. We need to remove sessionStorage 
        if(this.module === 'conference') {
            window.sessionStorage.removeItem('info-parent-booking');
            window.sessionStorage.removeItem('interview-description');
        }
        this.sessionService.deleteAdminSession()
            .subscribe(
                complete => {
                    // Clear user session
                    this.adminService.clearAdminSessionData();
                    this.adminService.clearInterSession();
                    // Fire user session data changed event
                    this.adminService.adminDataChanged(null);
                    // Redirect to desired URL
                    if(Object.values(devEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `http://${devEnv.auth}/login`;
                    }
                    else if(Object.values(testEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `http://${testEnv.auth}/login`;
                    }
                    else if(Object.values(bisHanoiEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `http://${bisHanoiEnv.auth}/login`;
                    }
                    else if(Object.values(bisHanoiDevEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `http://${bisHanoiDevEnv.auth}/login`;
                    }
                    else if(Object.values(stagingEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `https://${stagingEnv.auth}/login`;
                    }
                    else if(Object.values(procEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `https://${procEnv.auth}/login`;
                    }
                    else if(Object.values(demoEnv).indexOf(window.location.hostname) !== -1){
                        return window.location.href = `http://${demoEnv.auth}/login`;
                    }
                    else{
                        return window.location.href = `http://${localEnv.auth}/login`;
                    }
                },
                error    => this.errorMessage = <any> error
            );
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/components/admin-header-auth/AdminHeaderAuthComponent.ts